export const SeatFilterMap = [
  { parent: "academicyear",seats: "s001_academicyear"},
  { parent: "board", seats: "s001_allocationboard"},  
  { parent: "round",seats: "s001_round"},
  { parent: "quota",seats: "s001_statequota"},
  { parent: "insttype", seats: "s001_insttype"},
  { parent: "instname", seats: "s001_instname"},
  { parent: "branchname", seats: "s001_branchname"},
  { parent: "gender", seats: "s001_gender"},
  { parent: "category", seats: "s001_caste" },
  { parent: "common", seats: "s001_common" },
  { parent: "summary", seats: "s001_summary" },
];

export const CutoffFilterMap = [
  { parent: "academicyear", cutoffs: "c001_academicyear" },
  { parent: "board", cutoffs: "c001_allocationboard" },
  { parent: "round", cutoffs: "c001_round" },
  { parent: "quota", cutoffs: "c001_statequota" },
  { parent: "insttype", cutoffs: "c001_insttype" },
  { parent: "instname", cutoffs: "c001_instname" },
  { parent: "branchname", cutoffs: "c001_branchname" },
  { parent: "gender", cutoffs: "c001_gender" },
  { parent: "category", cutoffs: "c001_caste" },
  { parent: "common", cutoffs: "c001_common" },
  { parent: "summary", cutoffs: "c001_summary" },
  { parent: "max_round", cutoffs: "max_round" },
];

export const FilterConstants = [
  {
    title_id: 0,
    title: "Academic Year",
    parent: "academicyear",
    inputType: "dropdown",
    panel: "vertical",
    choiceArray: [
      { title: "AY2025-26", value: "AY2025-26" },
      { title: "AY2024-25", value: "AY2024-25" },
      { title: "AY2023-24", value: "AY2023-24" },
      { title: "AY2022-23", value: "AY2022-23" },
    ],
  },
  {
    title: "Allocation Board",
    parent: "allocationboard",
    inputType: "allocation-dropdown",
    panel: "vertical",
    boards: [
      { label: "JOSAA", value: "JOSAA" },
      { label: "CSAB", value: "CSAB" },
      { label: "MHTCET", value: "MHTET" },
      { label: "COMEDK", value: "COMEDK" },
    ],
    boardArray: [
      {
        title: "JOSAA",
        parent: "JOSAA",
        choiceArray: [
          {
            title: "Gender",
            parent: "gender",
            choiceArray: [
              { title: "Gender-Neutral", value: "GENDER-NEUTRAL" },
              {
                title: "Female Only (Incl. Supernumerary)",
                value: "FEMALE SUPERNUMERARY",
              },
              {
                title: "Female Supernumerary",
                value: "FS-NUMERARY",
              },
            ],
          },
          {
            title: "Round",
            parent: "round",
            choiceArray: [{ title: "CAPR0", value: "CAPR0" }],
          },
          {
            title: "Category",
            parent: "category",
            choiceArray: [
              { title: "OPEN", value: "OPEN" },
              { title: "GEN", value: "GEN" },
              { title: "EWS", value: "EWS" },
              { title: "PWD", value: "PWD" },
              { title: "OBC-NCL", value: "OBC-NCL" },
              { title: "SC", value: "SC" },
              { title: "ST", value: "ST" },
            ],
          },
          {
            title: "Quota",
            parent: "statequota",
            choiceArray: [
              { title: "AI", value: "AI" },
              { title: "GO", value: "GO" },
              { title: "HS", value: "HS" },
              { title: "JK", value: "JK" },
              { title: "LA", value: "LA" },
              { title: "OS", value: "OS" },
            ],
          },
        ],
      },
      {
        title: "CSAB",
        parent: "CSAB",
        choiceArray: [
          {
            title: "Gender",
            parent: "gender",
            choiceArray: [
              { title: "Gender-Neutral", value: "GENDER-NEUTRAL" },
              {
                title: "Female Only (Incl. Supernumerary)",
                value: "FEMALE ONLY (INCLUDING SUPERNUMERARY)",
              },
            ],
          },
          {
            title: "Round",
            parent: "round",
            choiceArray: [{ title: "R0", value: "R0" }],
          },
          {
            title: "Category",
            parent: "category",
            choiceArray: [
              { title: "OPEN", value: "OPEN" },
              { title: "GEN", value: "GEN" },
              { title: "EWS", value: "EWS" },
              { title: "PWD", value: "PWD" },
              { title: "OBC-NCL", value: "OBC-NCL" },
              { title: "SC", value: "SC" },
              { title: "ST", value: "ST" },
            ],
          },
          {
            title: "Quota",
            parent: "statequota",
            choiceArray: [
              { title: "AI", value: "AI" },
              { title: "GO", value: "GO" },
              { title: "HS", value: "HS" },
              { title: "JK", value: "JK" },
              { title: "LA", value: "LA" },
              { title: "OS", value: "OS" },
            ],
          },
        ],
      },
      {
        title: "MHTCET",
        parent: "MHTCET",
        choiceArray: [
          {
            title: "Gender",
            parent: "gender",
            choiceArray: [
              { title: "GENDER", value: "GENDER" },
              { title: "LADIES", value: "LADIES" },
            ],
          },
          {
            title: "Round",
            parent: "round",
            choiceArray: [
              { title: "BEFORE_CAPR1", value: "BEFORE_CAPR1" },
              { title: "BEFORE_CAPR2", value: "BEFORE_CAPR2" },
              { title: "BEFORE_CAPR3", value: "BEFORE_CAPR3" },
              { title: "AFTER_CAPR3", value: "AFTER_CAPR3" },
            ],
          },
          {
            title: "Category",
            parent: "category",
            choiceArray: [
              { title: "None", value: "AI" },
              { title: "OPEN", value: "OPEN" },
              { title: "GEN", value: "GEN" },
              { title: "OBC", value: "OBC" },
              { title: "SC", value: "SC" },
              { title: "ST", value: "ST" },
              { title: "EWS", value: "EWS" },
              { title: "PWD", value: "PWD" },
              { title: "DEF", value: "DEF" },
              { title: "TFWS", value: "TFWS" },
              {
                title: "Nomadic Tribes(VJDT/NTA)",
                value: "VJDT(NTA)",
              },
              {
                title: "Nomadic Tribes(NT1/NTB)",
                value: "NT1(NTB)",
              },
              {
                title: "Nomadic Tribes(NT2/NTC)",
                value: "NT2(NTC)",
              },
              {
                title: "Nomadic Tribes(NT3/NTD)",
                value: "NT3(NTD)",
              },
            ],
          },
          {
            title: "Quota",
            parent: "statequota",
            choiceArray: [
              { title: "ALL INDIA", value: "ALL INDIA" },
              { title: "HOME STATE", value: "HOME STATE" },
              {
                title: "OTHER THAN HOME STATE",
                value: "OTHER THAN HOME STATE",
              },
            ],
          },
        ],
      },
      {
        title: "COMEDK",
        parent: "COMEDK",
        choiceArray: [
          {
            title: "Round",
            parent: "round",
            choiceArray: [
              { title: "PROVISIONAL", value: "PROVISIONAL" },
              { title: "BEFORE_R1", value: "BEFORE_R1" },
              { title: "AFTER_R1", value: "AFTER_R1" },
              { title: "BEFORE_R2P1", value: "BEFORE_R2P1" },
              { title: "AFTER_R2P1", value: "AFTER_R2P1" },
              { title: "BEFORE_R2P2", value: "BEFORE_R2P2" },
              { title: "AFTER_R2P2", value: "AFTER_R2P2" },
              { title: "BEFORE_R3", value: "BEFORE_R3" },
              { title: "AFTER_R3", value: "AFTER_R3" },
              { title: "AFTER_R3_V1D1", value: "AFTER_R3_V1D1" },
            ],
          },
          {
            title: "Category",
            parent: "category",
            choiceArray: [
              { title: "GM", value: "GM" },
              { title: "KKR/HKR", value: "KKR/HKR" },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Branch:",
    parent: "branch",
    inputType: "dropdown",
    panel: "horizontal",
    choiceArray: [
      { title: "Computer", value: "COMPUTER" },
      { title: "Electronics", value: "ELECTRONICS" },
      { title: "Electrical", value: "ELECTRICAL" },
      { title: "Mechanical", value: "MECHANICAL" },
      { title: "Civil", value: "CIVIL" },
      { title: "Others", value: "OTHERS" },
    ],
  },
  {
    title_id: 6,
    title: "Institute Name:",
    parent: "instname",
    inputType: "text",
    panel: "horizontal",
  },
];
